<template>
  <div id="app" class="overflow-x-hidden h-screen" >
    <div v-if="showLayout">
      <header ref="headerElement"  class="h-20 flex items-center p-4 bg-menu-bg-color text-menu-text-color justify-between">
        <div class="flex items-center">
          <button aria-label="Toggle Navigation" class="p-1 mr-4 focus:outline-none" @click="sidebarOpen = !sidebarOpen">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-6 w-6">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <Link href="/dashboard" class="flex-grow md:flex-grow-0 ">

            <template v-if="userLogo">
                <img
                  class="h-12 m-auto w-full max-w-10"
                  :src="userLogo.original_url"
                  :alt="userLogo.name"
                />
            </template>
            <template v-else>
              <img v-if="
                $page.props.selectedLogo == 'BL' &&
                $page.props.defaultBlackLogo
              " :src="'/storage/' + $page.props.defaultBlackLogo" alt="default-logo" class="h-12 m-auto w-full max-w-10" />
              <img v-else-if="
                $page.props.selectedLogo == 'WL' &&
                $page.props.defaultWhiteLogo
              " :src="'/storage/' + $page.props.defaultWhiteLogo" alt="default-logo" class="h-12 m-auto w-full max-w-10" />
              <p v-else class="text-center text-menu-text-color">
                {{ $page.props.portalText }}
              </p>
            </template>
          </Link>
        </div>
        <div class="flex items-center">
          <ManageEmployeeModal class="hidden md:block mr-2" v-if="$page.props.isInvitationEnabled" />
          <p class="text-menu-font-size leading-menu-line-height text-center mr-2 lg:mr-8 hidden md:block" v-if="$page.props.loggedInText">
            {{ ___("SideNav|You are logged in as|content") }}:
            <span class="text-menu-font-size leading-menu-line-height">{{
                $page.props.accountName
            }} <span v-if="$page.props.showCustomerNumber">
            (<span v-if="$page.props.customerNumberPrefix ">
              {{ $page.props.customerNumberPrefix }}
            </span> {{ $page.props.customerNumber }} )</span> </span>
          </p>
          <p class="text-menu-font-size leading-menu-line-height text-center mr-2 lg:mr-0 hidden md:block" v-else-if="$page.props.showCustomerNumber">
            (<span v-if="$page.props.customerNumberPrefix ">
              {{ $page.props.customerNumberPrefix }}
            </span> {{ $page.props.customerNumber }} )
          </p>
          
          <div class="relative group" @click="isProfileOpen= !isProfileOpen" @mouseenter="isProfileOpen=true" @mouseleave="isProfileOpen=false">
            <button class="overflow-hidden border-2 border-menu-bg-color w-13 h-13 flex justify-center items-center | hover:border-primary-color focus:outline-none focus:border-primary-color">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </button>

            <div class="absolute z-60 right-0 py-3 transition" :class="{'hidden': !isProfileOpen}" @click.stop="">
              <div class="bg-menu-bg-color shadow-lg w-48">
                <Link href="/profile" as="link" class="block cursor-pointer text-menu-text-color text-menu-font-size px-4 py-3 | hover:bg-primary-color hover:text-primary-text-color">
                  {{ ___("Profile|Header|content") }}
                </Link>
                <Link href="/logout" method="post" as="link" class="block cursor-pointer text-menu-text-color text-menu-font-size px-4 py-3 | hover:bg-primary-color hover:text-primary-text-color">
                  {{ ___("SideNav|Logout|content") }}
                </Link>
                <a v-if="$page.props.isAdminUser === true" class="hidden md:block text-menu-text-color text-menu-font-size px-4 py-3 cursor-pointer | hover:bg-primary-color hover:text-primary-text-color">
                  <LanguageSwitcher userType="admin" :selectedLang="$page.props.userlanguage" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div :style="contentAreaStyle" class=" flex relative" >
        <SideNav :isOpen="sidebarOpen" v-on:closeNav="sidebarOpen = $event" />
        <div class=" bg-white bg-opacity-75 absolute w-full h-full z-10	" v-if="showloader">
            <div class="spinner relative flex self-center items-center justify-center w-full h-full p-8">
              <div class="w-32 h-32 rounded-full absolute border-8 border-solid border-primary-color-200">
              </div>
              <div class="w-32 h-32 absolute rounded-full animate-spin border-8 border-solid border-primary-color border-t-transparent">
              </div>
            </div>
          </div>
        <div class="flex-1 overflow-y-scroll overflow-x-hidden h-full relative" @scroll="handleScroll" ref="scrollContainer">
          <main class="py-4 px-6 ">
            <slot />
          </main>
        </div>
      </div>
    </div>
    <div class=" bg-white bg-opacity-75 absolute w-full h-full z-10	" v-if="showmainloader">
      <div class="spinner relative flex self-center items-center justify-center w-full h-full p-8">
        <div class="w-32 h-32 rounded-full absolute border-8 border-solid border-primary-color-200">
        </div>
        <div class="w-32 h-32 absolute rounded-full animate-spin border-8 border-solid border-primary-color border-t-transparent">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
import SideNav from "@/Shared/SideNav";
import LanguageSwitcher from "@/Components/LanguageSwitcher";
import ManageEmployeeModal from "@/Components/ManageEmployeeModal";

export default {
  components: {
    Link,
    SideNav,
    LanguageSwitcher,
    ManageEmployeeModal
  },
  data() {
    return {
      sidebarOpen: true,
      showLayout: false,
      showloader: false,
      showScrollToTop:false,
      userLogo: null,
      showmainloader:false,
      contentAreaStyle : {
        height: `calc(100vh - 80px)`
      },
      isProfileOpen: false,
    };
  },
  created() {
    this.isMobileScreen();
    this.$root.$on('open-loader', this.openLoader);
  },
  beforeMount() {
    if (localStorage.getItem("reloaded")) {
      localStorage.removeItem("reloaded");
      this.showLayout = true;
    } else if(this.$page.props.directLogin) {
      this.showmainloader = !this.showmainloader;
      localStorage.setItem("reloaded", "1");
      location.reload();
    }
    else if(!this.$page.props.directLogin){
      this.showLayout = true;
    }
  },
  methods: {
    isMobileScreen() {
      if (window.innerWidth >= 768) {
        return;
      } else {
        this.sidebarOpen = false;
      }
    },
    handleScroll(){
      const scrollContainer = this.$refs.scrollContainer;
      const scrollTop = scrollContainer.scrollTop;
      this.showScrollToTop = scrollTop > 200 ? true : false;
      this.$page.props.showScrollToTop = this.showScrollToTop;
    },
    scrollToTop() {
      const contentArea = this.$refs.scrollContainer;
      contentArea.scrollTo({ top: 0, behavior: 'smooth' });
    },
    openLoader() {
      this.showloader = !this.showloader;
    },
  },
  mounted() {
    if (this.$page.props.user && this.$page.props.user.media) {
      let isUserLogoPresent = this.$page.props.user.media.find(item => item.collection_name === 'userLogo');
      if(isUserLogoPresent){
        this.userLogo = isUserLogoPresent;
      }
    }
    const headerHeight = this.$refs.headerElement ? this.$refs.headerElement.clientHeight : 80;
    this.contentAreaStyle = {
      height: `calc(100vh - ${headerHeight}px)`
    };
  },
};
</script>
